import {
  Box,
  Grid,
  InputLabel,
  Typography,
  ListItemButton,
  Button,
  Divider,
  Skeleton,
  Checkbox,
  ThemeProvider,
  TextField,
  InputAdornment,
  IconButton,
} from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import CustomInput from '../../Main/Components/Custom/CustomInput';
import BookingData from '../../Assets/Dataa/BookingData';
import anime from '../../Assets/anime/done.json';
import Lottie from 'react-lottie';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  createReservationOffline,
  createReservationOfflineDeposit,
  createWaitlistOffline,
  getRestaurantDetails,
} from '../../api';
import Loader from '../../Main/Components/Common/Loader';
import { FiGift } from 'react-icons/fi';
import logo from '../../Assets/logo/logo.svg';
import { BsCalendar2CheckFill } from 'react-icons/bs';
import { BsFillPeopleFill } from 'react-icons/bs';
import { GoClockFill } from 'react-icons/go';
import queryString from 'query-string';
import { useSnackbar } from 'notistack';
import DietaryOptions from '../../Main/Components/Common/DietaryOptions';
import PaystackPaymentButton from '../../Main/Components/Common/PaystackPaymentButton';
import { Helmet } from 'react-helmet-async';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Modal from '@mui/material/Modal';
import { PiClockUserThin } from 'react-icons/pi';
import { Theme, ThemeForno, ThemeTerrace } from '../../Themes';
import coinAnime from '../../Assets/anime/coin.json';
import { isForno_Color, isReisty_Color, isTerrace_Color } from './WidgetConfig';
import { FaMinus, FaPlus } from 'react-icons/fa6';

export function generateUniqueCode(prefix = 'web_') {
  const timestamp = Date.now().toString();
  const randomChars = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `${prefix}${timestamp}${randomChars}`;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { lg: 400, md: 400, sm: 350, xs: 350 },
  bgcolor: 'background.paper',

  boxShadow: 24,
  p: 4,
  boxSizing: 'border-box',
  borderRadius: '10px',
  maxHeight: '70vh',
  overflowY: 'scroll',
};

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: anime,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const GiftInformation = ({}) => {
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const nameRef = useRef(null);
  const lastNameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: coinAnime,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [Dietary, setDietary] = useState('');
  const [occasion, setOccasion] = useState('');
  const [specialRequest, setSpecialRequest] = useState('');
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [openWaitlist, setOpenWaitlist] = useState(false);
  const [rulesChecked, setRulesChecked] = useState(false);
  const { name: restaurantName } = useParams();
  const [otherOccasions, setOtherOccasions] = useState('');
  const queryParams = queryString.parse(location.search);
  const [guest, setGuest] = useState(1);
  const {
    time,
    ReservationDay: date,
    deposit,
    floor,
    waitlist,
    pointValue,
    point_id,
    gift,
    gift_price,
    name,
  } = queryParams;

  useEffect(() => {
    if (occasion !== '') {
      setOtherOccasions('');
    }
  }, [occasion]);

  useEffect(() => {
    if (otherOccasions !== '') {
      setOccasion('');
    }
  }, [otherOccasions]);

  const capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const handleAlert = (variant, message) => {
    enqueueSnackbar(message, { variant });
  };

  const handleCreateReservation = async () => {
    setIsLoading(true);
    const groupMemberDietaryRestriction = Dietary?.join(', ');
    const newDeposit = deposit;

    const ref = generateUniqueCode();

    await createReservationOfflineDeposit(
      restaurant?.RestaurantId,
      floor,
      point_id || null,
      date,
      time,
      firstName,
      lastName,
      phoneNumber,
      email,
      parseFloat(guest),
      ref,
      occasion || otherOccasions,
      groupMemberDietaryRestriction,
      specialRequest,
      newDeposit,
      false,
      newDeposit * 100,
    )
      .then((res) => {
        if (res?.data?.status) {
          window.location.href = res?.data?.result?.authorization_url;
        } else {
          handleAlert('error', `${res?.data?.error_message}`);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err)
        setIsLoading(false);
        handleAlert('error', `${err?.message}`);
      });
  };
  const handleWaitlistReservation = async () => {
    const newName = firstName.trim();
    const newLname = lastName.trim();
    const newEmail = email.trim();
    const phone = phoneNumber.trim();

    if (!newName) {
      nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      nameRef.current?.focus();
      return;
    }

    if (!newLname) {
      lastNameRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      lastNameRef.current?.focus();
      return;
    }
    if (!phoneNumber || mobileError) {
      phoneRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      phoneRef.current?.focus();
      return;
    }
    if (!newEmail || emailError) {
      emailRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      emailRef.current?.focus();
      return;
    }

    setIsLoading(true);
    const groupMemberDietaryRestriction = Dietary?.join(', ');
    const newDeposit = deposit * guest;

    await createWaitlistOffline(
      restaurant?.RestaurantId,
      floor,
      point_id || null,
      date,
      time,
      firstName,
      lastName,
      phoneNumber,
      email,
      parseFloat(guest),
      occasion || otherOccasions,
      groupMemberDietaryRestriction,
      specialRequest,
      null,
      true,
    )
      .then((res) => {
        if (res?.data?.status) {
          setOpenWaitlist(true);
        } else {
          handleAlert('error', `${res?.data?.error_message}`);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        // console.log(err)
        setIsLoading(false);
        handleAlert('error', `${err?.message}`);
      });
  };

  const handleCreateReservation2 = async () => {
    const newName = firstName.trim();
    const newLname = lastName.trim();
    const newEmail = email.trim();
    const phone = phoneNumber.trim();

    if (!newName) {
      nameRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      nameRef.current?.focus();
      return;
    }

    if (!newLname) {
      lastNameRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
      lastNameRef.current?.focus();
      return;
    }
    if (!phoneNumber || mobileError) {
      phoneRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      phoneRef.current?.focus();
      return;
    }
    if (!newEmail || emailError) {
      emailRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      emailRef.current?.focus();
      return;
    }

    setIsLoading(true);
    const groupMemberDietaryRestriction = Dietary?.join(', ');

    try {
      const res = await createReservationOffline(
        restaurant?.RestaurantId,
        floor,
        point_id || null,
        date,
        time,
        firstName,
        lastName,
        phoneNumber,
        email,
        guest,
        occasion || otherOccasions,
        groupMemberDietaryRestriction,
        specialRequest,
        deposit,
        null,
        true,
      );

      if (res?.data?.status) {
        navigate(`/reservation/booked/${res?.data?.result[0]?.BookingId}`);
      } else {
        handleAlert('error', `${res?.data?.error_message}`);
      }
    } catch (err) {
      handleAlert('error', `${err?.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const [loading, setLoading] = useState(false);
  const [restaurant, setRestaurant] = useState(null);

  const handleGetRestaurantDetails = async () => {
    setLoading(true);
    await getRestaurantDetails(name)
      .then((res) => {
        setLoading(false);
        // console.log(res);
        if (res?.data?.status) {
          setRestaurant(res?.data?.result[0]);
        }
      })
      .catch((err) => {
        setLoading(false);
        // console.log(err);
      });
  };

  useEffect(() => {
    handleGetRestaurantDetails();
  }, []);

  const [mobileError, setMobileError] = useState('');

  const validateMobileNumber = (number) => {
    const mobilePattern = /^[0-9]{8,15}$/;
    return mobilePattern.test(number);
  };
  const handleMobileChange = (e) => {
    const mobileValue = e.target.value;
    setPhoneNumber(mobileValue);

    if (!validateMobileNumber(mobileValue)) {
      setMobileError('Please enter a valid mobile number.');
    } else {
      setMobileError('');
    }
  };

  const [emailError, setEmailError] = useState('');

  const validateEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);

    if (!validateEmail(emailValue)) {
      setEmailError('Please enter a valid email address.');
    } else {
      setEmailError('');
    }
  };

  const [currentTheme, setCurrentTheme] = useState(Theme);
  const [currentColor, setCurrentColor] = useState(isReisty_Color);

  // =======Restaurant config========

  const IS_TERRACE = restaurantName === 'the-terrace-lagos';
  const IS_FORNO = restaurantName === 'forno-lagos';

  useEffect(() => {
    if (IS_TERRACE) {
      setCurrentColor(isTerrace_Color);
      setCurrentTheme(ThemeTerrace);
    } else if (IS_FORNO) {
      setCurrentColor(isForno_Color);
      setCurrentTheme(ThemeForno);
    } else {
      setCurrentColor(isReisty_Color);
      setCurrentTheme(Theme);
    }
  }, [restaurantName]);

  const IS_SHIRO = restaurantName === 'shiro';
  const IS_HARDROCK = restaurantName === 'hard-rock-cafe';

  const deposit_charge =
    calculatePercentage(0.015, deposit) > 2000
      ? 2000
      : calculatePercentage(0.015, deposit);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <ThemeProvider theme={currentTheme}>
        {isLoading && <Loader />}
        <Box sx={{ bgcolor: currentColor.mainbg }}>
          {isSuccessful ? (
            <>
              <Box
                sx={{
                  boxSizing: 'border-box',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  mt: 4,
                  bgcolor: currentColor.mainbg,
                }}
              >
                <Lottie options={defaultOptions} width={400} height={200} />
                <Typography sx={{ fontSize: '18px', fontWeight: 700 }}>
                  Reservation Modified
                </Typography>
                <Typography>
                  Please check your inbox for a confirmation email.
                </Typography>
              </Box>
            </>
          ) : (
            <>
              <Box sx={{ bgcolor: currentColor.mainbg }}>
                <Box
                  align="center"
                  sx={{ pt: 4, bgcolor: currentColor.mainbg }}
                >
                  <img src={logo} width={90} />
                  <Typography sx={{ mt: 2, fontWeight: 700, fontSize: '16px' }}>
                    Complete Gift Reservation
                  </Typography>
                </Box>
                <Box
                  sx={{
                    margin: '0 auto',
                    mt: 4,
                    width: {
                      xl: '80%',
                      lg: '80%',
                      md: '90%',
                      sm: '100%',
                      xs: '100%',
                    },
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item lg={6}>
                      <Box sx={{ p: 3, boxSizing: 'border-box' }}>
                        <Typography sx={{ fontWeight: 600, mb: 2 }}>
                          Personal Details
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item lg={6} xs={6}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              First Name
                            </InputLabel>
                            <CustomInput
                              inputRef={nameRef}
                              fullWidth
                              small
                              value={firstName}
                              onChange={(e) => setFirstName(e.target.value)}
                            />
                          </Grid>
                          <Grid item lg={6} xs={6}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              Last Name
                            </InputLabel>
                            <CustomInput
                              inputRef={lastNameRef}
                              fullWidth
                              small
                              value={lastName}
                              onChange={(e) => setLastName(e.target.value)}
                            />
                          </Grid>
                          <Grid item lg={12} xs={12}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              Phone Number
                            </InputLabel>
                            <CustomInput
                              inputRef={phoneRef}
                              fullWidth
                              small
                              value={phoneNumber}
                              onChange={handleMobileChange}
                              error={mobileError}
                              helperText={mobileError}
                              type="number"
                            />
                          </Grid>
                          <Grid item lg={12} xs={12}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              {' '}
                              Email Address
                            </InputLabel>
                            <CustomInput
                              fullWidth
                              small
                              inputRef={emailRef}
                              value={email}
                              onChange={handleEmailChange}
                              error={emailError}
                              helperText={emailError}
                            />
                          </Grid>
                        </Grid>
                        <Typography sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
                          Who are you gifting
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item lg={6} xs={6}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              First Name
                            </InputLabel>
                            <CustomInput
                              inputRef={nameRef}
                              fullWidth
                              small
                              //   value={firstName}
                              //   onChange={(e) => setFirstName(e.target.value)}
                            />
                          </Grid>
                          <Grid item lg={6} xs={6}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              Last Name
                            </InputLabel>
                            <CustomInput
                              inputRef={lastNameRef}
                              fullWidth
                              small
                              //   value={lastName}
                              //   onChange={(e) => setLastName(e.target.value)}
                            />
                          </Grid>
                          <Grid item lg={12} xs={12}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              Phone Number
                            </InputLabel>
                            <CustomInput
                              inputRef={phoneRef}
                              fullWidth
                              small
                              //   value={phoneNumber}
                              //   onChange={handleMobileChange}
                              error={mobileError}
                              helperText={mobileError}
                              type="number"
                            />
                          </Grid>
                          <Grid item lg={12} xs={12}>
                            <InputLabel required sx={{ fontSize: '12px' }}>
                              {' '}
                              Email Address
                            </InputLabel>
                            <CustomInput
                              fullWidth
                              small
                              inputRef={emailRef}
                              //   value={email}
                              //   onChange={handleEmailChange}
                              error={emailError}
                              helperText={emailError}
                            />
                          </Grid>
                          <Grid item lg={12} xs={12}>
                            <Box>
                              <InputLabel>Number of Guest(s)</InputLabel>
                              <TextField
                                value={guest}
                                onChange={(e) => setGuest(e.target.value)}
                                type="number"
                                margin="dense"
                                fullWidth
                                error={!guest}
                                helperText={
                                  !guest && 'please enter a valid guest size'
                                }
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        disabled={isLoading || guest < 1}
                                        onClick={() => {
                                          if (guest > 1) {
                                            setGuest(guest - 1);
                                          }
                                        }}
                                        sx={{
                                          border: '1px solid ',
                                          borderRadius: '5px',
                                        }}
                                      >
                                        <FaMinus style={{ fontSize: '12px' }} />
                                      </IconButton>
                                      <IconButton
                                        onClick={() =>
                                          setGuest(
                                            (prev) => parseFloat(prev) + 1,
                                          )
                                        }
                                        disabled={
                                          (guest > 8 && IS_FORNO) || isLoading
                                        }
                                        sx={{
                                          border: '1px solid ',
                                          borderRadius: '5px',
                                          ml: 1,
                                        }}
                                      >
                                        <FaPlus style={{ fontSize: '12px' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                  style: {
                                    fontSize: '12px',
                                    borderRadius: '8px',
                                  },
                                  disabled: isLoading || guest < 0,
                                  inputMode: 'numeric',
                                  pattern: '[0-9]*',
                                }}
                              />
                            </Box>
                          </Grid>
                        </Grid>

                        {parseFloat(gift_price) > 0 && (
                          <Box
                            sx={{
                              mt: 3,
                              borderRadius: '8px',
                              border: '1px solid #d7d7d7',
                            }}
                          >
                            <Box
                              sx={{ p: 2, borderBottom: '1px solid #d7d7d7' }}
                            >
                              <Typography
                                color="primary"
                                sx={{ fontWeight: 600 }}
                              >
                                Reservation Deposit
                              </Typography>
                            </Box>
                            <Box
                              sx={{ p: 2, borderBottom: '1px solid #d7d7d7' }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography
                                  sx={{
                                    fontSize: '12px',
                                    fontWeight: 500,
                                    textTransform: 'uppercase',
                                  }}
                                >{`${gift} x ${guest}`}</Typography>
                                <Typography
                                  sx={{ fontSize: '12px', fontWeight: 500 }}
                                >
                                  ₦
                                  {parseFloat(gift_price) *
                                    parseFloat(guest).toLocaleString()}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{ p: 2, borderBottom: '1px solid #d7d7d7' }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: '12px', fontWeight: 500 }}
                                >
                                  Charge
                                </Typography>
                                <Typography
                                  sx={{ fontSize: '12px', fontWeight: 500 }}
                                >
                                  ₦
                                  {IS_SHIRO || IS_HARDROCK
                                    ? deposit_charge.toLocaleString()
                                    : 0}
                                </Typography>
                              </Box>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  mt: 1,
                                }}
                              >
                                <Typography
                                  sx={{ fontSize: '12px', fontWeight: 500 }}
                                >
                                  Total
                                </Typography>
                                <Typography
                                  sx={{ fontSize: '12px', fontWeight: 500 }}
                                >
                                  ₦
                                  {IS_SHIRO || IS_HARDROCK
                                    ? (
                                        parseFloat(deposit) + deposit_charge
                                      )?.toLocaleString()
                                    : (
                                        parseFloat(gift_price) *
                                        parseFloat(guest)
                                      ).toLocaleString()}
                                </Typography>
                              </Box>
                            </Box>
                            <Box
                              sx={{
                                p: 2,
                                bgcolor: `${currentColor.primary}0d`,
                                borderRadius: '0px 0px 8px 8px',
                              }}
                            >
                              <Typography
                                sx={{
                                  textDecoration: 'underline',
                                  fontSize: '12px',
                                  fontWeight: 600,
                                }}
                              >
                                Disclaimer
                              </Typography>
                              <Typography sx={{ fontSize: '10px' }}>
                                {IS_SHIRO || IS_HARDROCK ? (
                                  <p>
                                    We Understand That Plans May Change. If You
                                    Need to Cancel, Please Take Note of Our
                                    Cancellation terms: •⁠ ⁠Cancellation Within
                                    7 Days: No Cancellation Fee Applies. •⁠
                                    ⁠Cancellation Within 2-6 Days: 10%
                                    Cancellation Fee Applies. •⁠ ⁠⁠Cancellation
                                    Within 24 Hours: 25% Cancellation Fee
                                    Applies. •⁠ ⁠⁠No-Shows: Full Payment Is
                                    Non-Refundable. To Cancel Or Reschedule
                                    Contact Us at{' '}
                                    {IS_SHIRO && (
                                      <a
                                        href="tel:+234 818 629 8888"
                                        style={{
                                          textDecoration: 'underline',
                                          fontWeight: 500,
                                        }}
                                      >
                                        +234 818 629 8888
                                      </a>
                                    )}{' '}
                                    {IS_HARDROCK && (
                                      <a
                                        href="tel:+234 908 198 8888"
                                        style={{
                                          textDecoration: 'underline',
                                          fontWeight: 500,
                                        }}
                                      >
                                        +234 908 198 8888
                                      </a>
                                    )}{' '}
                                    To Modify Or Cancel Your Reservation.{' '}
                                  </p>
                                ) : (
                                  <p>
                                    {' '}
                                    This deposit will be deducted from your
                                    final bill after the reservation has been
                                    concluded. In the event you need to cancel
                                    your reservation, please ensure you do so at
                                    least 12 hours before the reservation time,
                                    and the deposit will be refunded to your
                                    bank account. You will receive a reservation
                                    reminder 13 hours before your reservation
                                    time.
                                  </p>
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                        <Typography sx={{ fontWeight: 600, mb: 1, mt: 4 }}>
                          Lets help you plan your visit
                        </Typography>
                        <Typography sx={{ fontSize: '12px', color: '#333' }}>
                          To aid {restaurantName} Restaurant in organizing your
                          visit, kindly provide answers to the questions below.
                        </Typography>
                        <Box
                          sx={{
                            mt: 2,
                            borderRadius: '10px',
                            border: '1px solid #d7d7d7',
                            p: 2,
                          }}
                        >
                          <Typography
                            sx={{ fontWeight: 500, fontSize: '12px' }}
                          >
                            What occasion are you celebrating?
                          </Typography>

                          <Box sx={{ mt: 2 }}>
                            <Grid container spacing={2}>
                              {BookingData?.map((item, index) => {
                                const isSelected = item?.title === occasion;
                                return (
                                  <Grid item lg={6} xs={6} key={index}>
                                    <ListItemButton
                                      selected={isSelected}
                                      onClick={() => setOccasion(item?.title)}
                                      sx={{
                                        width: '100%',
                                        display: 'flex',
                                        columnGap: 2,
                                        p: 2,
                                        border: '1px solid #d7d7d7',
                                        borderRadius: '8px',
                                        ...(isSelected && {
                                          border: '1px solid ',
                                          borderColor: currentColor.primary,
                                        }),
                                      }}
                                    >
                                      <img
                                        width={25}
                                        src={
                                          isSelected ? item?.icon2 : item?.icon1
                                        }
                                      />
                                      <Typography
                                        color={isSelected && 'primary'}
                                        sx={{ fontSize: '12px' }}
                                      >
                                        {item?.title}
                                      </Typography>
                                    </ListItemButton>
                                  </Grid>
                                );
                              })}
                              <Grid item lg={12} xs={12}>
                                <Box>
                                  <TextField
                                    variant="outlined"
                                    value={otherOccasions}
                                    onChange={(e) =>
                                      setOtherOccasions(e.target.value)
                                    }
                                    label="Others"
                                    fullWidth
                                    InputProps={{
                                      style: { borderRadius: '8px' },
                                    }}
                                  />
                                </Box>
                              </Grid>
                            </Grid>
                            <Divider sx={{ mt: 2 }} />
                            <Box sx={{ mt: 3 }}>
                              <DietaryOptions
                                updateDietary={(value) => setDietary(value)}
                              />
                              {/* <CustomInput
                          value={Dietary}
                          onChange={(e) => setDietary(e.target.value)}
                          placeholder="Your  input here"
                          multiline
                          fullWidth
                          margin="dense"
                          minRows={3}
                        /> */}
                            </Box>
                            <Box sx={{ mt: 3 }}>
                              <Typography
                                sx={{ fontWeight: 500, fontSize: '12px' }}
                              >
                                Do have any special request?
                              </Typography>

                              <CustomInput
                                value={specialRequest}
                                onChange={(e) =>
                                  setSpecialRequest(e.target.value)
                                }
                                placeholder="Your  input here"
                                multiline
                                fullWidth
                                margin="dense"
                                minRows={2}
                              />
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item lg={6}>
                      <Box
                        sx={{
                          p: 3,
                          boxSizing: 'border-box',
                          position: 'sticky',
                          top: 0,
                        }}
                      >
                        <Box
                          sx={{
                            border: '1px solid #d7d7d7',
                            p: 2,
                            borderRadius: '8px',
                          }}
                        >
                          <Typography sx={{ fontWeight: 700 }}>
                            Gift Reservation Details
                          </Typography>
                          <Typography sx={{ mt: 2 }}>
                            {restaurantName}
                          </Typography>
                          <Divider sx={{ my: 1 }} />
                          <Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: 1,
                                mt: 1,
                              }}
                            >
                              <FiGift style={{ fontSize: '14px' }} />
                              <Typography sx={{ fontSize: '12px' }}>
                                {gift}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: 1,
                                mt: 0.4,
                              }}
                            >
                              <BsFillPeopleFill style={{ fontSize: '14px' }} />
                              <Typography
                                sx={{ fontSize: '12px' }}
                              >{`${guest} Guest`}</Typography>
                            </Box>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: 1,
                                mt: 0.4,
                              }}
                            >
                              <GoClockFill style={{ fontSize: '14px' }} />
                              <Typography sx={{ fontSize: '12px' }}>
                                {time}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                        <Box
                          sx={{
                            mt: 3,
                            p: 2,
                            border: '1px solid #d7d7d7',
                            borderRadius: '8px',
                          }}
                        >
                          <Box>
                            <Typography
                              sx={{ fontWeight: 600, fontSize: '12px' }}
                            >
                              Cancellation policy
                            </Typography>
                            {restaurant?.Experience && (
                              <>
                                {restaurant?.Experience?.CancellationPolicy ? (
                                  <ReactQuill
                                    value={
                                      restaurant?.Experience?.CancellationPolicy
                                    }
                                    readOnly={true}
                                    theme={null} // Disable theme
                                    modules={{ toolbar: false }}
                                    style={{
                                      fontFamily: 'lato',

                                      padding: '0%',
                                    }}
                                    className="ql-editor" // Apply custom CSS class
                                  />
                                ) : (
                                  <Typography
                                    sx={{
                                      fontSize: '10px',
                                      mt: 1,
                                      textAlign: 'justify',
                                    }}
                                  >
                                    We understand that circumstances can change,
                                    and if you need to cancel, there won't be
                                    any charges. However, we kindly request that
                                    you notify us at least 24 hours prior to
                                    your scheduled time.
                                  </Typography>
                                )}
                              </>
                            )}
                          </Box>
                        </Box>
                        <Box sx={{ my: 2 }}>
                          <Typography
                            sx={{ fontWeight: 600, textAlign: 'center' }}
                          >
                            Reservation being held for {time}
                          </Typography>
                        </Box>
                        <Box sx={{ mt: 2 }}>
                          {loading ? (
                            <>
                              <Skeleton width={'100%'} height={100} />
                            </>
                          ) : (
                            <>
                              {restaurant?.Experience?.HouseRules && (
                                <>
                                  <Box
                                    sx={{
                                      mt: 1,
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <Checkbox
                                      checked={rulesChecked}
                                      onClick={handleOpen}
                                    />{' '}
                                    <Typography sx={{ fontWeight: 500 }}>
                                      Click to view and accept the house rules
                                      terms.
                                    </Typography>
                                  </Box>
                                </>
                              )}
                            </>
                          )}
                        </Box>
                        {pointValue &&
                          point_id &&
                          pointValue !== 'null' &&
                          point_id !== 'null' && (
                            <Box
                              sx={{
                                my: 2,
                                p: 3,
                                bgcolor: `${currentColor.primary}0d`,
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'column',
                                borderRadius: '8px',
                              }}
                            >
                              <Lottie
                                options={defaultOptions}
                                width={150}
                                height={100}
                              />
                              <Typography sx={{ textAlign: 'center' }}>
                                Complete your reservation now and grab <br />
                                <span
                                  style={{
                                    fontFamily: 'optima',
                                    fontWeight: 700,
                                    fontSize: '22px',
                                  }}
                                >
                                  {pointValue}
                                </span>{' '}
                                points!
                              </Typography>
                              <Typography
                                sx={{
                                  mt: 1,
                                  fontSize: '12px',
                                  fontStyle: 'italic',
                                }}
                              >
                                collect more to win exciting prizes!
                              </Typography>
                            </Box>
                          )}

                        {waitlist === 'true' ? (
                          <Button
                            variant="contained"
                            fullWidth
                            sx={{ mt: 5, borderRadius: '50px', py: 2 }}
                            onClick={handleWaitlistReservation}
                          >
                            Join the waitlist
                          </Button>
                        ) : (
                          <>
                            {deposit > 0 ? (
                              <>
                                <Box
                                  sx={{
                                    p: 2,
                                    border: '1px solid #d7d7d7',
                                    borderRadius: '8px',
                                  }}
                                >
                                  <Box
                                    sx={{
                                      pb: 2,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'space-between',
                                    }}
                                  >
                                    <Typography sx={{ fontWeight: 400 }}>
                                      Payment Method
                                    </Typography>
                                    <Typography sx={{ fontWeight: 600 }}>
                                      Pay Online
                                    </Typography>
                                  </Box>
                                </Box>

                                <Button
                                  disabled={
                                    !firstName ||
                                    !lastName ||
                                    !email ||
                                    (restaurant?.Experience?.HouseRules !==
                                      '<p>﻿</p>' &&
                                      !rulesChecked)
                                  }
                                  onClick={handleCreateReservation}
                                  variant="contained"
                                  fullWidth
                                  sx={{ mt: 5, borderRadius: '10px', py: 2 }}
                                >
                                  Make Payment
                                </Button>
                              </>
                            ) : (
                              <Button
                                disabled={
                                  !firstName ||
                                  !lastName ||
                                  !email ||
                                  (restaurant?.Experience?.HouseRules &&
                                    restaurant?.Experience?.HouseRules !==
                                      '<p>﻿</p>' &&
                                    !rulesChecked)
                                }
                                onClick={handleCreateReservation2}
                                variant="contained"
                                fullWidth
                                sx={{ mt: 5, borderRadius: '50px', py: 2 }}
                              >
                                Complete Gift Reservation
                              </Button>
                            )}
                          </>
                        )}

                        {/* first_name, last_name, email, amount, onSuccessAction, label  */}
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </>
          )}
        </Box>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>
              House Rules
            </Typography>
            <Divider sx={{ mt: 1 }} />
            <Box sx={{ mt: 2, mx: -3 }}>
              {restaurant?.Experience && (
                <ReactQuill
                  value={restaurant?.Experience?.HouseRules}
                  readOnly={true}
                  theme={null} // Disable theme
                  modules={{ toolbar: false }}
                  style={{
                    fontFamily: 'lato',

                    padding: '0%',
                  }}
                  className="ql-editor" // Apply custom CSS class
                />
              )}
            </Box>

            <Box align="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                onClick={(e) => {
                  setRulesChecked(true);
                  handleClose();
                }}
              >
                Accept
              </Button>
            </Box>
          </Box>
        </Modal>

        <Modal
          open={openWaitlist}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box sx={{ mt: 2 }} align="center">
              <PiClockUserThin
                style={{ fontSize: '60px', color: '#FFA500 ' }}
              />
              <h3
                style={{
                  fontFamily: 'optima',
                  textAlign: 'center',
                  fontSize: '30px',
                }}
              >
                You’re Now on the Waitlist
              </h3>
              <Typography sx={{ mt: -3 }}>
                We’re preparing to accommodate you. Please wait for further
                updates.
              </Typography>
            </Box>

            <Box align="center" sx={{ mt: 5 }}>
              <Button
                variant="contained"
                sx={{ width: '230px', height: '45px', borderRadius: '8px' }}
                onClick={(e) => {
                  navigate(`/${restaurantName}/reservation`);
                }}
              >
                Thank You
              </Button>
            </Box>
          </Box>
        </Modal>
      </ThemeProvider>
    </>
  );
};

export default GiftInformation;

function formatDate(inputDate) {
  // Create a Date object
  const date = new Date(inputDate);

  // Define an array of day and month names
  const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const monthsOfYear = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];

  // Extract the day of the week, month, and day of the month
  const dayOfWeek = daysOfWeek[date.getDay()];
  const month = monthsOfYear[date.getMonth()];
  const dayOfMonth = date.getDate();

  // Format the date string
  const formattedDate = `${dayOfWeek}, ${month} ${dayOfMonth}`;

  return formattedDate;
}

function calculatePercentage(percent, amount) {
  return Math.ceil((amount + 100) / (1 - percent));
}
